<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <!-- <b-card-body> -->
        <data-table
          ref="RateCard"
          :data-table="dataRateCardItem"
          :field-table="dataRateCardField"
          :status="dataRateCardStatus"
          :table-for="table"
          :data-for="dataFor"
          :mutation-for="mutationFor"
          :list="list"
          :action="action"
          :button-add="buttonAdd"
          @addList="callFormAdd"
        >
          <!-- <template #head(checkbox)="data">
            <b-form-checkbox
              :key="data.key"
              v-model="checkAll"
              @input="selectAll"
            />
          </template>
          <template #cell(checkbox)="data">
            <b-form-checkbox
              :checked="data.rowSelected"
              disabled
            />
          </template>
          <template #cell(start_date)="data">
            {{ formatDateIdr(data.value) }}
          </template>
          <template #cell(end_date)="data">
            {{ formatDateIdr(data.value) }}
          </template>
          <template #cell(budget)="data">
            {{ formatPrice(data.value) }}
          </template> -->
          <template #cell(volume)="data">
            {{ formatPrice(data.value) }}
          </template>
          <template
            #cell(actions)="data"
          >
            <b-button
              variant="outline-primary"
              size="sm"
              @click="callFormEdit(data.item.id)"
            >
              <span class="align-middle">Edit</span>
            </b-button>
          </template>
        </data-table>
        <!-- </b-card-body> -->
        <popup-form
          ref="popups"
          :form-title="formTitle"
          :edit-status="editStatus"
          :data-form="dataFormTemp"
        />
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
} from 'bootstrap-vue'
import DataTable from '@/views/component/DataTable.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import PopupForm from '@/views/component/PopupRateCard.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    DataTable,
    PopupForm,
  },
  data() {
    return {
      formTitle: 'Form Title',
      table: 'ratecard',
      dataFor: 'dataRateCard',
      mutationFor: 'RATECARD',
      list: 'getRateCard',
      dataForm: {},
      dataFormTemp: {},
      action: false,
      checkAll: false,
      selected: false,
      buttonAdd: true,
      editStatus: false,
    }
  },
  computed: {
    ...mapGetters('ratecard', {
      dataRateCardField: 'getRateCardField',
      dataRateCardItem: 'getRateCardItem',
      dataRateCardStatus: 'getRateCardStatus',
    }),
  },
  mounted() {
    this.clearTable()
    // this.setId()
    // this.resetRow()
    this.getRateCard()
  },
  methods: {
    ...mapActions('ratecard', [
      'getRateCard',
      'clearTable',
    ]),
    ...mapMutations('datas', {
      resetRow: 'setSelectedRow',
    }),
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    callFormAdd() {
      this.dataFormTemp = {}
      this.formTitle = 'Add New Channel'
      this.editStatus = false
      this.$refs.popups.popupShow()
    },
    callFormEdit(id) {
      // this.dataFormTemp = this.dataRateCardItem.data.find(item => item.id === id)
      this.dataFormTemp = JSON.parse(JSON.stringify(this.dataRateCardItem.data.find(item => item.id === id)))
      this.formTitle = 'Edit Channel'
      this.editStatus = true
      this.$refs.popups.popupShow()
    },
    resetForm() {

    },
  },
}
</script>

<style scoped>
input[type="checkbox"]:disabled + label::before{
  background: rgb(138, 44, 44);
}
input[type="checkbox"]:disabled + label:hover::before{
  background: rgb(122, 59, 59);
  border: 1px solid #d4d4d5;
}

</style>
